// Heading — presentation primitive.
// Props:
//   level:   1|2|3|4|5|6                                     (default 2)
//   variant: 'display'|'page'|'section'|'subsection'         (default 'page')
//   tone:    'primary'|'secondary'|'tertiary'                (default 'primary')
//   icon:    string (Font Awesome class)                     (optional)
//   className, id, children, ...rest
//
// The optional `icon` slot exists to express the design's
// `[icon] [H2]` section-header rhythm primitive (design/design-map.md
// §A.4). It is rendered as a leading <i aria-hidden="true">, leaving
// the children as the accessible heading text. Selector-free,
// dispatch-free, ownership-agnostic per CLAUDE.md Presentation
// Primitive Rules.

function Heading({
  level = 2,
  variant = 'page',
  tone = 'primary',
  icon,
  className = '',
  children,
  ...rest
}) {
  const Tag = `h${Math.min(Math.max(level, 1), 6)}`;
  const classes = [
    'ui-heading',
    `ui-heading--${variant}`,
    `ui-heading--tone-${tone}`,
    icon ? 'ui-heading--with-icon' : '',
    className,
  ].filter(Boolean).join(' ');

  return (
    <Tag className={classes} {...rest}>
      {icon ? (
        <i className={`ui-heading__icon ${icon}`} aria-hidden="true" />
      ) : null}
      <span className="ui-heading__text">{children}</span>
    </Tag>
  );
}

export default Heading;
